import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    query: null,
    check:false

};

const searchQuerySlice = createSlice({
    name: "searchQuerySlice",
    initialState,
    reducers: {
        updateQuery: (state, action) => {
            state.query = action.payload;
        },
        setCheck:(state, action)=>{
            state.check=action.payload
        }
    },
});

export const {
    updateQuery,
    setCheck
} = searchQuerySlice.actions;

export default searchQuerySlice.reducer;
